import React from "react";
import {
  Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table,
} from '@material-ui/core';

const cellCommonStyle = { border: '1px solid #e0e0e0', padding: '2px', paddingLeft: '5px', paddingRight: '5px' };
const cell40 = { ...cellCommonStyle, width: '40%' };
const cell20 = { ...cellCommonStyle, width: '20%' };
const cell100 = { ...cellCommonStyle, width: '100%' };
const cell80 = { ...cellCommonStyle, width: '80%' };

export default class ComponentToPrint extends React.Component {

  render() {
    const income = this.props.income;
    const stockValue = this.props.stockValue;
    const administrationExpenses = this.props.administrationExpenses;
    const distributionExpenses = this.props.distributionExpenses;
    const financialExpenses = this.props.financialExpenses;
    const otherExpenses = this.props.otherExpenses;
    const totals = this.props.totals;
    const selectedSearchValues = this.props.selectedSearchValues;

    const incomeLabels = ['Sales', 'Cutter Tea', 'Tea Sales Profit'];
    const incomeKeys = ['SalesProceedIncome', 'RefuseTeaIncome', 'LocalSales'];
    const stockLables = ['Opening Finished Goods', 'Manufacturing Cost'];
    const stockKeys = ['OpeningBalance', 'ProductionCost'];
    const otherIncomeLabels = ['Fertilizer Sale Profit', 'Interest Income', 'Groceries Profit', 'Transport Income', 'Vegetable Sale Profit', 'Chemical Sale Profit', 'Other Income'];
    const otherIncomeKeys = ['FertilizerSaleProfit', 'InterestIncome', 'GroceriesProfit', 'TransportIncome', 'VegetableSaleProfit', 'ChemicalSaleProfit', 'OtherIncome'];
    const administrationLabels = ['Water Bill','Telephone (SLT & Mobitel)', 'New Year Bonus', 'Salary', 'EPF', 'ETF', 'Meals Expenses', 'Electricity', 'Sundry', 'Printing & Stationery', 'Postage', 'Watchers', 'Motor Vehicle Depreciation', 'Fertilizer Loading and Unloading', 'Annual Expenses'];
    const administrationKeys = ['Water', 'TotalTelephoneChargersWithStarLink', 'Bonus', 'OfficeStaffSalary', 'StaffEPF', 'StaffETFWithEmployeeTrustFund', 'MealsExpenses', 'ElectricityCharges', 'SundryExpenses', 'PrintingAndStationary', 'Postage', 'SecurityOfficersSalary', 'VehicleDepreciation','FertilizerLoadingAndUnloading', 'AnnualExpenses'];
    const distributionExpensesLabels = ['Colombo Tea Transport', 'Motor Vehicle Depreciation (Colombo)', 'Marketing Cost', 'Sample Cost', 'Diesel Expenses', 'Vehicle Maintenance']
    const distributionExpensesKeys = ['MadeTeaTransport', 'VehicleDepreciationColombo', 'Brokerage', 'SampleCost', 'Fuel', 'VehicleMaintenance'];
    const financialExpensesLabels = ['Loan Interest', 'OD Interest', 'Bank Charges'];
    const financialExpensesKeys = ['LoanInterest', 'ODInterest', 'BankCharges'];
    const otherExpensesLabels = ['Medical', 'Donation', 'Welfare'];
    const otherExpensesKeys = ['MedicalExpenses', 'Donation', 'Welfare'];

    return (
      <div>
        <div>&nbsp;</div>
        <div className="row pl-2 pb-4 pt-4">
          <h3><center> {selectedSearchValues.groupName}&nbsp; {selectedSearchValues.factoryName} </center></h3>
          <h3><center>  PROFIT AND LOSS STATEMENT FOR THE MONTH OF {selectedSearchValues.applicableMonth}, {selectedSearchValues.applicableYear}</center></h3>
          <div>&nbsp;</div>
        </div>
        <div>

          <Box minWidth={650}>
            <TableContainer style={{ border: '1px solid #e0e0e0', borderRadius: 4 }}>
              <Table size="small" aria-label="simple table" style={{ borderCollapse: 'collapse', width: '100%' }}>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={4} align="left" style={cell100}>
                      <b>Description</b>
                    </TableCell>
                  </TableRow>

                  {incomeKeys.map((key, rowIndex) => (
                    <TableRow key={rowIndex}>
                      <TableCell align="left" style={cell40}>
                        {incomeLabels[rowIndex]}
                      </TableCell>
                      <TableCell align="right" style={cell20}></TableCell>
                      <TableCell align="right" style={cell20}></TableCell>
                      <TableCell align="right" style={cell20}>{income[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                    </TableRow>
                  ))}

                  <TableRow>
                    <TableCell colSpan={3} align="left" style={cell80}></TableCell>
                    <TableCell align="right" style={{ ...cell20, borderTop: '2px solid #000000' }}><b>{totals.SalesTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={4} align="left" style={cell100}><u>Cost of Sales</u></TableCell>
                  </TableRow>

                  {stockKeys.map((key, rowIndex) => (
                    <TableRow key={rowIndex}>
                      <TableCell align="left" style={cell40}>
                        {stockLables[rowIndex]}
                      </TableCell>
                      <TableCell align="right" style={cell20}></TableCell>
                      <TableCell align="right" style={cell20}>{typeof stockValue[key] === 'number' ? stockValue[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : (stockValue[key] ?? '')}</TableCell>
                      <TableCell align="right" style={cell20}></TableCell>
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell colSpan={4} align="left" style={{ ...cell100, height: '1.5rem' }}></TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell align="left" style={cell40}>Cutter tea</TableCell>
                    <TableCell align="right" style={cell20}></TableCell>
                    <TableCell align="right" style={cell20}></TableCell>
                    <TableCell align="right" style={cell20}></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left" style={cell40}>Locally sold stock</TableCell>
                    <TableCell align="right" style={cell20}></TableCell>
                    <TableCell align="right" style={cell20}></TableCell>
                    <TableCell align="right" style={cell20}></TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={4} align="left" style={{ ...cell100, height: '1.5rem' }}></TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell align="left" style={cell40}>Closing Finished Goods</TableCell>
                    <TableCell align="right" style={cell20}></TableCell>
                    <TableCell align="right" style={{ ...cell20, borderBottom: '2px solid #000000' }}>{stockValue['ClosingBalance'].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                    <TableCell align="right" style={{ ...cell20, borderBottom: '2px solid #000000' }}><b>{totals.StockValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b> </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell align="left" style={cell40}>Gross Profit</TableCell>
                    <TableCell align="right" style={cell20}></TableCell>
                    <TableCell align="right" style={cell20}></TableCell>
                    <TableCell align="right" style={cell20}><b>{totals.GrossProfit.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={4} align="left" style={{ ...cell100, height: '1.5rem' }}></TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={4} align="left" style={cell100}><u>Other Income</u></TableCell>
                  </TableRow>

                  {otherIncomeKeys.map((key, rowIndex) => (
                    <TableRow key={rowIndex}>
                      <TableCell align="left" style={cell40}>
                        {otherIncomeLabels[rowIndex]}
                      </TableCell>
                      <TableCell align="right" style={cell20}></TableCell>
                      <TableCell align="right" style={rowIndex === otherIncomeKeys.length - 1 ? { ...cell20, borderBottom: '2px solid #000000' } : cell20}>{typeof income[key] === 'number' ? income[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : (income[key] ?? '')}</TableCell>
                      {rowIndex === otherIncomeKeys.length - 1 ? <TableCell align="right" style={{ ...cell20, borderBottom: '2px solid #000000' }}><b>{totals.TotalOtherIncome.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b> </TableCell> : <TableCell align="right" style={cell20}></TableCell>}
                    </TableRow>
                  ))}

                  <TableRow>
                    <TableCell colSpan={3} align="left" style={cell40}></TableCell>
                    <TableCell align="right" style={cell20}><b>{totals.TotalIncome.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={4} align="left" style={{ ...cell100, height: '1.5rem' }}></TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={4} align="left" style={cell100}><u>Administration Expenses</u></TableCell>
                  </TableRow>

                  {administrationKeys.map((key, rowIndex) => (
                    <TableRow key={rowIndex}>
                      <TableCell align="left" style={cell40}>
                        {administrationLabels[rowIndex]}
                      </TableCell>
                      <TableCell align="right" style={rowIndex === administrationKeys.length - 1 ? { ...cell20, borderBottom: '2px solid #000000' } : cell20}>
                        {typeof administrationExpenses[key] === 'number'
                          ? administrationExpenses[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                          : (administrationExpenses[key] ?? '')}
                      </TableCell>
                      {rowIndex === administrationKeys.length - 1 ? <TableCell align="right" style={{ ...cell20, borderBottom: '2px solid #000000' }}><b>{totals.TotalAdministrationExpenses.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell> : <TableCell align="right" style={cell20}></TableCell>}
                      <TableCell align="right" style={cell20}></TableCell>
                    </TableRow>
                  ))}

                  <TableRow>
                    <TableCell colSpan={4} align="left" style={{ ...cell100, height: '1.5rem' }}></TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={4} align="left" style={cell100}><u>Distribution Expenses</u></TableCell>
                  </TableRow>

                  {distributionExpensesKeys.map((key, rowIndex) => (
                    <TableRow key={rowIndex}>
                      <TableCell align="left" style={cell40}>
                        {distributionExpensesLabels[rowIndex]}
                      </TableCell>
                      <TableCell align="right" style={rowIndex === distributionExpensesKeys.length - 1 ? { ...cell20, borderBottom: '2px solid #000000' } : cell20}>
                        {typeof distributionExpenses[key] === 'number'
                          ? distributionExpenses[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                          : (distributionExpenses[key] ?? '')}
                      </TableCell>
                      {rowIndex === distributionExpensesKeys.length - 1 ? <TableCell align="right" style={{ ...cell20, borderBottom: '2px solid #000000' }}><b>{totals.TotalDistributionExpenses.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell> : <TableCell align="right" style={cell20}></TableCell>}
                      <TableCell align="right" style={cell20}></TableCell>
                    </TableRow>
                  ))}

                  <TableRow>
                    <TableCell colSpan={4} align="left" style={{ ...cell100, height: '1.5rem' }}></TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={4} align="left" style={cell100}><u>Financial Expenses</u></TableCell>
                  </TableRow>

                  {financialExpensesKeys.map((key, rowIndex) => (
                    <TableRow key={rowIndex}>
                      <TableCell align="left" style={cell40}>
                        {financialExpensesLabels[rowIndex]}
                      </TableCell>
                      <TableCell align="right" style={rowIndex === financialExpensesKeys.length - 1 ? { ...cell20, borderBottom: '2px solid #000000' } : cell20}>
                        {typeof financialExpenses[key] === 'number'
                          ? financialExpenses[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                          : (financialExpenses[key] ?? '')}
                      </TableCell>
                      {rowIndex === financialExpensesKeys.length - 1 ? <TableCell align="right" style={{ ...cell20, borderBottom: '2px solid #000000' }}><b>{totals.TotalFinancialExpenses.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell> : <TableCell align="right" style={cell20}></TableCell>}
                      <TableCell align="right" style={cell20}></TableCell>
                    </TableRow>
                  ))}

                  <TableRow>
                    <TableCell colSpan={4} align="left" style={{ ...cell100, height: '1.5rem' }}></TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={4} align="left" style={cell100}><u>Other Expenses</u></TableCell>
                  </TableRow>

                  {otherExpensesKeys.map((key, rowIndex) => (
                    <TableRow key={rowIndex}>
                      <TableCell align="left" style={cell40}>
                        {otherExpensesLabels[rowIndex]}
                      </TableCell>
                      <TableCell align="right" style={cell20}>
                        {typeof otherExpenses[key] === 'number'
                          ? otherExpenses[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                          : (otherExpenses[key] ?? '')}
                      </TableCell>
                      {rowIndex === otherExpensesKeys.length - 1 ? <TableCell align="right" style={cell20}><b>{totals.TotalOtherExpenses.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b> </TableCell> : <TableCell align="right" style={cell20}></TableCell>}
                      {rowIndex === otherExpensesKeys.length - 1 ? <TableCell align="right" style={cell20}><b>{totals.TotalExpenses.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell> : <TableCell align="right" style={cell20}></TableCell>}
                    </TableRow>
                  ))}

                  <TableRow style={{ borderTop: '2px solid #000000' }}>
                    <TableCell colSpan={3} align="left" style={cell80}>Profit / (Loss)</TableCell>
                    <TableCell align="right" style={cell20}><b>{totals.ProfitORLoss.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell>
                  </TableRow>

                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </div>
      </div>
    );
  }
}